export const truncatedTextStyles = {
	endEllipsis: {
		display: 'block',
		minWidth: 0,
		maxWidth: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},

	middleRoot: (hasAdornment: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		gap: hasAdornment ? 1 : 0.5,
		minWidth: 0,
		maxWidth: '100%',
		overflow: 'hidden'
	}),

	middleText: {
		minWidth: 0,
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},

	adornment: {
		display: 'flex',
		alignItems: 'center',
		flexShrink: 0
	}
};
